<template lang="html">
  <div>
    <pl-dialog :padding="'2em 3em'" :max-width="'900px'" :height="'80%'">
      <div class="mv3 center-xs trial-teacher-title b">
        Include Free Trial Teachers
      </div>
      <div class="trial-teacher-sub-title">
        This is a list of teachers whose accounts are not upgraded, but whose
        email addresses also match the approved email suffixes for your school /
        district. Check any teachers whose data you’d like to include in your
        data analytics results. Parlay will automatically save your selection
        for next time.
      </div>
      <div class="row mv3">
        <div class="col-xs-6">
          <pl-input
            v-if="!loading"
            v-model="user_search"
            placeholder="Search by name"
            @keyup.enter="filters"
          />
        </div>
        <div class="col-xs-6">
          <pl-input
            v-if="!loading"
            v-model="email_search"
            placeholder="Search by email"
            @keyup.enter="filters"
          />
        </div>
      </div>
      <div class="mv3">
        <div v-if="loading" class="row modal-body mt5 center-xs">
          <pl-spinner class="x2" />
        </div>
        <div
          v-else-if="!loading && !trialTeachers.length"
          class="modal-body pt5 center-xs b"
        >
          No users.
        </div>
        <table v-else-if="!loading && trialTeachers.length" class="w-100">
          <thead>
            <tr class="row no-margin">
              <td class="col-xs-1 b"></td>
              <td class="col-xs-3 b">Name</td>
              <td class="col-xs-4 b">Email</td>
              <td class="col-xs-2 b">Role</td>
              <td class="col-xs-2 b">Last Active</td>
            </tr>
          </thead>
          <tbody id="trial_teachers-table" @scroll="handleScroll">
            <tr
              class="row no-margin middle-xs"
              v-for="(user, index) in trialTeachers"
            >
              <td class="col-xs-1">
                <pl-checkbox :value="user.id" v-model="selectedTrialTeachers" />
              </td>
              <td class="col-xs-3 middle-xs flex" style="padding-left: 0;">
                <div
                  class="avatar-circle avatar-size mr2"
                  :style="{
                    backgroundImage: 'url(' + user.avatar_url + ')',
                    'background-size': 'cover',
                    'background-position': 'center',
                  }"
                ></div>
                <span class="truncate-text" :title="user.name">
                  {{ user.name }}
                </span>
              </td>
              <td class="col-xs-4 truncate-text" :title="user.email">
                {{ user.email }}
              </td>
              <td class="col-xs-2 user-role">
                {{ user.role }}
              </td>
              <td class="col-xs-2 center-xs">{{ user.last_active }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row w-100 center-xs" style="height: 30px;">
          <div v-if="loading_table_body">
            <pl-spinner class="x5" />
          </div>
        </div>
      </div>
      <div class="row justify-center">
        <pl-button class="pl-white" @click.native="$emit('close')">
          CANCEL
        </pl-button>
        <pl-button
          class="f3 pl-primary b truncate-text"
          @click.native="submitConfirm"
          :disabled="!has_changes"
        >
          SAVE AND CLOSE
        </pl-button>
      </div>
    </pl-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';

  export default {
    data() {
      return {
        confirm: '',
        errorMessage: '',
        trialTeachers: [],
        selectedTrialTeachers: [],
        initTrialTeachers: [],
        user_search: '',
        email_search: '',
        page_number: 1,
        loading: false,
        show_more_trial_teachers: true,
        loading_table_body: false,
      };
    },
    props: {},
    computed: {
      ...mapGetters(['getCurrentSchool']),
      has_changes() {
        return !this.arraysAreIdentical(
          this.selectedTrialTeachers,
          this.initTrialTeachers
        );
      },
    },
    methods: {
      getTrialTeachers(is_filter, onScroll) {
        if (!onScroll) {
          this.loading = true;
        } else {
          this.loading_table_body = true;
        }

        if (is_filter) {
          this.trialTeachers = [];
        }

        const filters = {
          name: this.user_search,
          email: this.email_search,
          page: this.page_number,
        };

        adminServices
          .getTrialTeachers(this.$route.params.schoolID, filters)
          .then(({ data }) => {
            if (data && data.length > 0) {
              this.trialTeachers.push(...data);
              if (data.length === 20) {
                this.page_number += 1;
              } else {
                this.show_more_trial_teachers = false;
              }
            } else {
              this.show_more_trial_teachers = false;
            }
          })
          .catch((error) => {
            EventBus.$emit('toast-msg', 'Failure. Please try again.');
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
            this.loading_table_body = false;
          });
      },
      filters() {
        this.trialTeachers = [];
        this.show_more_trial_teachers = true;
        this.page_number = 1;

        this.getTrialTeachers(true);
      },
      elementHasReachedScrollEnd(elementId) {
        const element = document.getElementById(elementId);
        return (
          element.scrollHeight - Math.floor(element.scrollTop) ===
            element.clientHeight ||
          element.scrollHeight - Math.round(element.scrollTop) ===
            element.clientHeight
        );
      },
      handleScroll() {
        if (
          this.elementHasReachedScrollEnd('trial_teachers-table') &&
          this.show_more_trial_teachers
        ) {
          this.getTrialTeachers(false, true);
        }
      },
      arraysAreIdentical(arr1, arr2) {
        if (arr1.length !== arr2.length) return false;
        for (var i = 0, len = arr1.length; i < len; i++) {
          if (arr1[i] !== arr2[i]) {
            return false;
          }
        }
        return true;
      },
      submitConfirm() {
        const payload = {
          trial_teachers: this.selectedTrialTeachers,
        };
        adminServices
          .editSchool(this.$route.params.schoolID, payload)
          .then(({ data }) => {
            this.$store.dispatch('updateSchoolDetails', data);
            this.$emit('searchAnalytics');
            this.$emit('close');
          })
          .catch(() => {
            this.alertToast('Failure');
            this.$emit('close');
          });
      },
    },
    mounted() {
      this.getTrialTeachers();
      this.selectedTrialTeachers = this.getCurrentSchool.trial_teachers.map(
        (t) => t
      );
      this.initTrialTeachers = this.selectedTrialTeachers.slice();
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
  .trial-teacher-title
    font-size: 28px
    color: #292929
  .trial-teacher-sub-title
    color: #595959
    font-weight: 400
  .modal-body
    height: calc(80vh - 330px)
  table
    tbody
      display:block
      overflow-y: auto
      height: calc(80vh - 360px)
      padding-right: 3px
      tr
        height: 50px
        border: 2px solid #e1e8ee
        border-bottom: none
        &:last-child
          border-bottom: 3px solid #e1e8ee
      td
        color: #797979
        font-weight: 400
  .avatar-size
    min-width: 30px
    min-height: 30px
    max-width: 30px
    max-height: 30px
  .user-role
    text-transform: capitalize
  ::-webkit-scrollbar
    display: block
    width: 10px
    -webkit-appearance: none
</style>



// WEBPACK FOOTER //
// trialTeachersModal.vue?6046a390